(function () {
  var ROOT_SEL = '[data-revahs-upg]';
  var CFG_SEL = '[data-revahs-upg-config]';
  var DEFAULT_ATC_SEL = "[data-pf-type='ProductATC2']";

  function $(sel, scope) { return (scope || document).querySelector(sel); }
  function $all(sel, scope) { return Array.prototype.slice.call((scope || document).querySelectorAll(sel)); }

  function safeJsonParse(str) {
    try { return JSON.parse(str || '{}'); } catch (e) { return {}; }
  }

  function formatMoneyFromCents(cents, locale, currency) {
    try {
      return new Intl.NumberFormat(locale, { style: 'currency', currency: currency })
        .format((cents || 0) / 100);
    } catch (e) {
      return '€ ' + (((cents || 0) / 100).toFixed(2)).replace('.', ',');
    }
  }

  function initOne(root) {
    if (!root || root.dataset.revahsUpgInited === '1') return;
    root.dataset.revahsUpgInited = '1';

    var cfgEl = $(CFG_SEL, root);
    if (!cfgEl) return;

    var cfg = safeJsonParse(cfgEl.textContent);

    var baseId = String(cfg.baseVariantId || '');
    var proId  = String(cfg.proVariantId || '');
    if (!baseId || !proId) return;

    var baseHandle = String(cfg.baseHandle || '');
    var proHandle  = String(cfg.proHandle || '');
    if (!baseHandle || !proHandle) return;

    var atcSel = String(cfg.pageflyAtcSelector || DEFAULT_ATC_SEL);
    var locale = String(cfg.locale || 'nl-NL');
    var currency = String(cfg.currency || 'EUR');
    var rootUrl = String(cfg.rootUrl || '').replace(/\/$/, '');

    var labelBase = String(cfg.selectedModelBase || '');
    var labelPro  = String(cfg.selectedModelPro || '');
    var suffixBase = String(cfg.selectedSuffixBase || '');
    var suffixPro  = String(cfg.selectedSuffixPro || '');
    var deltaSuffix = String(cfg.deltaSuffix || 't.o.v. basis');

    var cards = $all('[data-upg-card]', root);
    var selected = root.getAttribute('data-default') === 'base' ? 'base' : 'pro';

    var priceState = { base: null, pro: null };

    function getVariantId(key) { return key === 'base' ? baseId : proId; }

    function getSelectedKey() {
      var checked = root.querySelector('[data-upg-card][aria-checked="true"]');
      if (checked) return checked.getAttribute('data-key') || selected;
      return selected;
    }

    function setPriceUI(key, priceCents, compareCents) {
      var nowEl = root.querySelector('[data-upg-price="' + key + '"]');
      var wasEl = root.querySelector('[data-upg-compare="' + key + '"]');

      if (nowEl) nowEl.textContent = formatMoneyFromCents(priceCents, locale, currency);

      if (wasEl) {
        if (compareCents && compareCents > priceCents) {
          wasEl.hidden = false;
          wasEl.textContent = formatMoneyFromCents(compareCents, locale, currency);
        } else {
          wasEl.hidden = true;
        }
      }
    }

    function updateDelta() {
      var deltaWrap = root.querySelector('[data-upg-delta]');
      if (!deltaWrap) return;

      var txtEl = deltaWrap.querySelector('[data-upg-delta-text]');
      if (!txtEl) return;

      if (typeof priceState.base !== 'number' || typeof priceState.pro !== 'number') {
        deltaWrap.hidden = true;
        return;
      }

      var diff = priceState.pro - priceState.base;
      if (diff <= 0) {
        deltaWrap.hidden = true;
        return;
      }

      var diffFormatted = formatMoneyFromCents(diff, locale, currency);
      txtEl.textContent = '+ ' + diffFormatted + ' ' + deltaSuffix;

      deltaWrap.hidden = false;
    }

    function fetchProduct(handle, cb) {
      if (!handle) return cb(null);

      var bust = Date.now();
      var url = rootUrl + '/products/' + encodeURIComponent(handle) + '.js?__revahs=' + bust;

      fetch(url, { credentials: 'same-origin', cache: 'no-store' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (data) { cb(data); })
        .catch(function () { cb(null); });
    }

    function loadPrices() {
      fetchProduct(baseHandle, function (p) {
        if (!p || !p.variants) return;

        var v = p.variants.find(function (x) { return String(x.id) === baseId; });
        if (!v) return;

        priceState.base = Number(v.price);
        setPriceUI('base', Number(v.price), Number(v.compare_at_price || 0));
        updateDelta();
      });

      fetchProduct(proHandle, function (p) {
        if (!p || !p.variants) return;

        var v = p.variants.find(function (x) { return String(x.id) === proId; });
        if (!v) return;

        priceState.pro = Number(v.price);
        setPriceUI('pro', Number(v.price), Number(v.compare_at_price || 0));
        updateDelta();
      });
    }

   function syncVariantToATC() {
  var key = getSelectedKey();
  var variantId = String(getVariantId(key));

  var nodes = $all(atcSel);

  for (var i = 0; i < nodes.length; i++) {
    var el = nodes[i];

    el.setAttribute('data-variant-id', variantId);
    el.setAttribute('data-varient-id', variantId);
    el.setAttribute('data-pf-variant-id', variantId);
    el.setAttribute('data-pf-product-variant-id', variantId);
    el.setAttribute('data-pf-variant', variantId);
    el.dataset.variantId = variantId;
    el.dataset.productVariantId = variantId;

    var form = el.closest && el.closest('form');
    if (!form && el.tagName && el.tagName.toLowerCase() === 'form') {
      form = el;
    }

    if (form) {
      var selectors = [
        'input[name="id"]',
        'input[name="variant_id"]',
        'input[data-product-variant-id]',
        'select[name="id"]'
      ];

      for (var j = 0; j < selectors.length; j++) {
        var input = form.querySelector(selectors[j]);
        if (!input) continue;

        if (input.tagName && input.tagName.toLowerCase() === 'select') {
          input.value = variantId;
        } else {
          input.value = variantId;
          input.setAttribute('value', variantId);
          input.setAttribute('data-product-variant-id', variantId);
        }

        try {
          input.dispatchEvent(new Event('input', { bubbles: true }));
          input.dispatchEvent(new Event('change', { bubbles: true }));
        } catch (e) {}
      }

      var hiddenId = form.querySelector('input[name="id"]');
      if (!hiddenId) {
        hiddenId = document.createElement('input');
        hiddenId.type = 'hidden';
        hiddenId.name = 'id';
        hiddenId.value = variantId;
        form.appendChild(hiddenId);

        try {
          hiddenId.dispatchEvent(new Event('input', { bubbles: true }));
          hiddenId.dispatchEvent(new Event('change', { bubbles: true }));
        } catch (e) {}
      }
    }
  }

  var globalInputs = $all('form[action*="/cart/add"] input[name="id"], input[name="id"], select[name="id"]');
  for (var k = 0; k < globalInputs.length; k++) {
    var g = globalInputs[k];

    if (g.tagName && g.tagName.toLowerCase() === 'select') {
      g.value = variantId;
    } else {
      g.value = variantId;
      g.setAttribute('value', variantId);
      g.setAttribute('data-product-variant-id', variantId);
    }

    try {
      g.dispatchEvent(new Event('input', { bubbles: true }));
      g.dispatchEvent(new Event('change', { bubbles: true }));
    } catch (e) {}
  }
}

    function syncSelectedLine() {
      var key = getSelectedKey();
      var modelEl = root.querySelector('[data-upg-selected-model]');
      var suffixEl = root.querySelector('[data-upg-selected-suffix]');

      if (modelEl) {
        if (key === 'base' && labelBase) modelEl.textContent = labelBase;
        if (key === 'pro' && labelPro) modelEl.textContent = labelPro;
      }

      if (suffixEl) {
        if (key === 'base' && suffixBase) suffixEl.textContent = suffixBase;
        if (key === 'pro' && suffixPro) suffixEl.textContent = suffixPro;
      }
    }

    function setSelected(key) {
      selected = (key === 'base') ? 'base' : 'pro';

      for (var i = 0; i < cards.length; i++) {
        var c = cards[i];
        var isActive = c.getAttribute('data-key') === selected;

        c.setAttribute('aria-checked', isActive ? 'true' : 'false');

        if (isActive) {
          c.classList.add('is-selected');
        } else {
          c.classList.remove('is-selected');
        }
      }

      syncVariantToATC();
      syncSelectedLine();
    }

    for (var i = 0; i < cards.length; i++) {
      (function (card) {
        card.addEventListener('click', function () {
          setSelected(card.getAttribute('data-key'));
        });

        card.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            setSelected(card.getAttribute('data-key'));
          }
        });
      })(cards[i]);
    }

    var modal = root.querySelector('[data-revahs-upg-modal]');

    function openModal() {
      if (modal) {
        modal.classList.add('is-open');
        modal.setAttribute('aria-hidden', 'false');
      }
    }

    function closeModal() {
      if (modal) {
        modal.classList.remove('is-open');
        modal.setAttribute('aria-hidden', 'true');
      }
    }

    var openBtn = root.querySelector('[data-revahs-upg-open]');
    if (openBtn) openBtn.addEventListener('click', openModal);

    $all('[data-revahs-upg-close]', root).forEach(function (btn) {
      btn.addEventListener('click', closeModal);
    });

    $all('[data-revahs-upg-pick]', root).forEach(function (btn) {
      btn.addEventListener('click', function () {
        setSelected(btn.getAttribute('data-revahs-upg-pick'));
        closeModal();
      });
    });

    setSelected(selected);
    loadPrices();

    var t = null;
    var obs = new MutationObserver(function () {
      if (t) return;
      t = setTimeout(function () {
        t = null;
        syncVariantToATC();
        $all(ROOT_SEL).forEach(initOne);
      }, 150);
    });

    obs.observe(document.documentElement, { childList: true, subtree: true });
  }

  function boot() {
    $all(ROOT_SEL).forEach(initOne);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();